/**
 * Icon Helper Functions
 *
 * Provides state and tag color configuration for asset icons
 */

// Base state colors for most asset types (machinery, water, chemicals, etc.)
const baseStateColors = {
  'available': {
    pinColor: '#0d3825',
    ringColor: 'white',
    iconColor: '#0d3825'
  },
  'locked_out': {
    pinColor: '#0d3825',
    ringColor: '#ef4444',  // Red ring
    iconColor: '#0d3825'
  },
  // 'empty': {
  //   pinColor: '#0d3825',
  //   ringColor: '#EFCB19',  // Yellow ring
  //   iconColor: '#0d3825'
  // },
  // 'low': {
  //   pinColor: '#0d3825',
  //   ringColor: '#F5A01B',  // Orange ring
  //   iconColor: '#0d3825'
  // },
  // 'out_of_action': {
  //   pinColor: '#0d3825',
  //   ringColor: '#E24E4C',  // Red ring
  //   iconColor: '#0d3825'
  // },
  'other': {
    pinColor: '#0d3825',
    ringColor: 'white',  // Blue ring
    iconColor: '#0d3825'
  }
};

// Category-specific color overrides
const categoryColorOverrides = {
  'water': {
    'available': { ringColor: '#31A6C5' },  // Sky blue for water assets
    'low': { ringColor: '#EFCB19' },        // Yellow for low water
    'empty': { ringColor: '#F5A01B' }       // Orange for empty water
  }
};

/**
 * Get colors for state-based icons (machinery, water, chemicals, etc.)
 *
 * @param {string|null} state - Asset state (available, locked_out, empty, low, out_of_action, other)
 * @param {string} category - Asset category for category-specific overrides (e.g., 'water')
 * @returns {object} Color configuration with pinColor, ringColor, iconColor
 */
export const getStateColors = (state, category = 'default') => {
  const baseColors = baseStateColors[state] || baseStateColors['available'];
  const overrides = categoryColorOverrides[category]?.[state] || {};
  return { ...baseColors, ...overrides };
};

/**
 * Get colors for livestock/animal icons (use tag color instead of state)
 *
 * @param {string|null} tagColorHex - Hex color code from mob's tag_colour (e.g., '#FF5733')
 * @returns {object} Color configuration with pinColor, ringColor, iconColor
 */
export const getAnimalColors = (tagColorHex) => {
  return {
    pinColor: '#0d3825',
    ringColor: tagColorHex || '#0d3825',  // Use tag color, or default to yellow
    iconColor: '#0d3825'
  };
};
